<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center">
      <b-col md="8" sm="12">
        <b-card no-body class="mx-6">
          <b-card-header>
            <b-link :variant="''" v-b-toggle.criteria>
              <h4>Transaction Selection Criteria</h4>
            </b-link>
          </b-card-header>
          <b-collapse visible id="criteria">
            <b-card-body class="p-6">
              <b-form>
                <b-row>
                  <b-col sm="12">
                    <b-form-group>
                      <label for="name">Date Range</label>
                      <date-picker
                        v-model="selectedRange"
                        class="form-control"
                        type="date"
                        :not-after="new Date()"
                        lang="en"
                        range
                        :shortcuts="rangeShortcut"
                        format="YYYY-MM-DD"
                        range-separator="thru"
                        confirm
                      ></date-picker>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <b-form-group>
                      <label for="name">Partner</label>
                      <b-form-input
                        v-model="partnerName"
                        type="text"
                        placeholder="Enter partner name"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <b-form-group>
                      <label for="name">Drug Name</label>
                      <b-form-input v-model="drugName" type="text" placeholder="Enter drug name"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <b-form-group>
                      <label for="name">NDC(s)</label>
                      <multiselect
                        v-model="ndcSelected"
                        :options="[]"
                        :multiple="true"
                        :taggable="true"
                        @tag="addNdc"
                        :clear-on-select="true"
                        placeholder="Enter an NDC 11 code e.g. 12345678901"
                      ></multiselect>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <b-form-group>
                      <label for="name">Physician NPI(s)</label>
                      <multiselect
                        v-model="npiSelected"
                        :options="[]"
                        :multiple="true"
                        :taggable="true"
                        @tag="addNpi"
                        :clear-on-select="true"
                        placeholder="Enter an NPI code e.g. 1234567890"
                      ></multiselect>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group>
                      <b-form-checkbox-group
                        id="selectedOfferQualifications"
                        name="selectedOfferQualifications"
                        v-model="selectedOfferQualifications"
                        :options="offerQualifications"
                      ></b-form-checkbox-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col>
                    <b-form-group>
                      <b-form-checkbox
                        id="EnableOfferDisposition"
                        v-model="enableOfferDisposition"
                      >Select by Offer Disposition</b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col offset="1">
                    <b-form-group>
                      <b-form-checkbox-group
                        id="offerStatuses"
                        name="offerStatuses"
                        v-model="selectedSuggestionOfferStatuses"
                        :options="suggestionOfferStatuses"
                        :disabled="!enableOfferDisposition"
                      ></b-form-checkbox-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="3" sm="3">
                    <b-button variant="light" block v-on:click="clear()">Clear</b-button>
                  </b-col>
                  <b-col cols="3" sm="3" offset="3" offset-sm="3">
                    <b-button variant="primary" block v-on:click="newSearch()">
                      Search
                      <i v-if="isSearchBusy" class="fa fa-spinner fa-pulse button-spinner"></i>
                    </b-button>
                  </b-col>
                  <b-col cols="3" sm="3">
                    <b-button
                      variant="primary"
                      block
                      v-b-modal.exportFieldChooser>
                      Export
                      <i v-if="isExportBusy" class="fa fa-spinner fa-pulse button-spinner"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="searchResults">
      <b-col lg="12">
        <b-card>
          <b-card-header>
            <b-row>
              <b-col>
                <h4>Transactions</h4>
              </b-col>
              <b-col>
                <div class="pull-right">
                  <h5>Total Records: {{searchResults.total}}</h5>
                </div>
              </b-col>
            </b-row>
          </b-card-header>
          <b-table
            :sort:by.sync="sortBy"
            @sort-changed="sortingChanged"
            :sort-desc.sync="sortDesc"
            striped
            hover
            :fields="fields"
            :items="searchResults.records"
            no-local-sorting
          ></b-table>
          <b-pagination
            align="center"
            :total-rows="searchResults.total"
            v-model="currentPage"
            :per-page="size"
            @input="changePage"
          ></b-pagination>
        </b-card>
      </b-col>
    </b-row>
    <ExportFieldChooser :fields="this.exportFields" v-on:saveExportFields="saveExportFields" v-on:doExport="exportData"></ExportFieldChooser>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import ExportFieldChooser from "../components/ExportFieldChooser";

import { SAVE_RTPS_EXPORT_FIELDS } from '../store/rtps/rtps.mutations';
import { RTPS_HISTORY_SEARCH, RTPS_HISTORY_EXPORT } from "../store/rtps/rtps.actions";
import { mapState } from "vuex";

const ndcSelected = [];
const npiSelected = [];
export default {
  name: "RTPSPortal",
  components: {
    Multiselect,
    DatePicker,
    ExportFieldChooser
  },
  data() {
    return {
      currentPage: 1,
      size: 20,
      offerQualifications: [
        { text: "No Offer Qualified", value: "notqualified" },
        { text: "Offer Qualified", value: "qualified" }
      ],
      selectedOfferQualifications: ["qualified", "notqualified"],
      enableOfferDisposition: true,
      suggestionOfferStatuses: [
        { text: "Offer Accepted", value: "accepted" },
        { text: "Offer Declined", value: "declined" },
        { text: "Rx Canceled", value: "canceled" },
        { text: "Disposition Unknown", value: "unknown" }
      ],
      selectedSuggestionOfferStatuses: [
        "accepted",
        "declined",
        "canceled",
        "unknown"
      ],
      ndcSelected: ndcSelected,
      npiSelected: npiSelected,
      drugName: "",
      partnerName: "",
      selectedRange: [getStartDate(), getEndDate()],
      rangeShortcut: [
        {
          text: "previous 7 days",
          onClick: () => {
            let d = new Date();
            d.setDate(d.getDate() - 7);
            d.setHours(0, 0, 0, 0);
            this.selectedRange = [d, getEndDate()];
          }
        },
        {
          text: "previous 30 days",
          onClick: () => {
            let d = new Date();
            d.setDate(d.getDate() - 30);
            d.setHours(0, 0, 0, 0);
            this.selectedRange = [d, getEndDate()];
          }
        }
      ],
      sortBy: "request_date",
      sortDesc: true,
      fields: [
        { key: "tracking_id", label: "Tracking ID", sortable: true },
        {
          key: "request_date",
          label: "Offer Date",
          sortable: true,
          formatter: value => {
            return new Date(value).toLocaleString();
          }
        },
        { key: "partner_network_name", label: "Partner", sortable: true },
        { key: "copay_offer_name", label: "Offer", sortable: true },
        { key: "npi_num", label: "Physician NPI", sortable: true },
        { key: "drug_name", sortable: true },
        { key: "ndc_num", label: "NDC", sortable: true },
        {
          key: "offer_qualification",
          label: "Offer Qualification",
          formatter: value => {
            if (value === "notqualified") {
              return "Not Qualified";
            }
            return value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
          },
          sortable: true
        },
        {
          key: "suggestion_offer_status",
          label: "Offer Accepted",
          sortable: true,
          formatter: value => {
            return value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
          }
        },
        { key: "ndc_prescribed_num", label: "NDC Prescribed", sortable: true }
      ],
      exportFields: [],
      defaultExportFields: [
        { key: 'alternatives', name: 'Alternatives', active: false, selected: false },
        { key: 'bin', name: 'Bin', active: false, selected: false },
        { key: 'copay_offer_id', name: 'Offer ID', active: false, selected: false },
        { key: 'copay_offer_name', name: 'Offer', active: false, selected: true },
        { key: 'drug_name', name: 'Drug Name', active: false, selected: true },
        { key: 'group_id', name: 'Group ID', active: false, selected: false },
        { key: 'manufacture_id', name: 'Manufacturer ID', active: false, selected: false },
        { key: 'manufacture_name', name: 'Manufacturer Name', active: false, selected: false },
        { key: 'member_id', name: 'Member ID', active: false, selected: false },
        { key: 'ndc_num', name: 'NDC', active: false, selected: true },
        { key: 'npi_num', name: 'Physician NPI', active: false, selected: true },
        { key: 'offer_long_text', name: 'Offer Long Text', active: false, selected: false },
        { key: 'offer_qualification', name: 'Offer Qualification', active: false, selected: true },
        { key: 'offer_short_text', name: 'Offer Short Text', active: false, selected: false },
        { key: 'out_of_pocket_maximum_amt', name: 'Out of Pocket Max', active: false, selected: false },
        { key: 'out_of_pocket_minimum_amt', name: 'Out of Pocket Min', active: false, selected: false },
        { key: 'partner_network_id', name: 'Partner ID', active: false, selected: false },
        { key: 'partner_network_name', name: 'Partner', active: false, selected: true },
        { key: 'pcn', name: 'PCN', active: false, selected: false },
        { key: 'request_date', name: 'Offer Date', active: false, selected: true },
        { key: 'rx_disposition_code', name: 'Rx Disposition Code', active: false, selected: false },
        { key: 'segment_id', name: 'Segment ID', active: false, selected: false },
        { key: 'suggestion_offer_status', name: 'Offer Accepted', active: false, selected: true },
        { key: 'tracking_id', name: 'Tracking ID', active: false, selected: true },
        { key: 'patient_age', name: 'Patient Age', active: false, selected: false },
        { key: 'patient_dob', name: 'Patient Date Of Birth', active: false, selected: false },
        { key: 'prescriber_state', name: 'Prescriber State', active: false, selected: false },
        { key: 'prescriber_zip', name: 'Prescriber Zip', active: false, selected: false }
      ]
    };
  },
  created: function() {
    if (this.exportFields.length === 0) {
      if (this.savedExportFields && this.savedExportFields.length > 0) {
        this.exportFields = Object.assign([], this.savedExportFields);
      }
      this.exportFields = Object.assign([], this.defaultExportFields);
    }
  },
  beforeMount: function() {
    if (this.savedExportFields && this.savedExportFields.length > 0) {
      this.exportFields = Object.assign([], this.savedExportFields);
    }
  },
  computed: {
    ...mapState({
      searchCriteria: state => state.rtps.searchCriteria,
      searchResults: state => state.rtps.searchResults,
      isExportBusy: state => state.rtps.isExportBusy,
      isSearchBusy: state => state.rtps.isSearchBusy,
      savedExportFields: state => state.rtps.savedExportFields
    })
  },
  methods: {
    newSearch() {
      if (!this.$store.state.rtps.isSearchBusy) {
        this.currentPage = 1;
        this.search();
      }
    },
    search() {
      if (!this.$store.state.rtps.isSearchBusy) {
        this.$store.dispatch(RTPS_HISTORY_SEARCH, this.getCriteria());
      }
    },
    clear() {
      this.ndcSelected = [];
      this.npiSelected = [];
      this.selectedOfferQualifications = ["qualified", "notqualified"];
      this.enableOfferDisposition = true;
      this.pharmaCompany = "";
      this.selectedSuggestionOfferStatuses = [
        "accepted",
        "declined",
        "canceled",
        "unknown"
      ];
      this.selectedRange = [getStartDate(), getEndDate()];
      this.drugName = "";
      this.partnerName = "";
    },
    exportData(selectedFields) {
      if (!this.isExportBusy) {
        var criteria = this.getCriteria();
        criteria.size = 10000;
        criteria.page = 1;
        var mergedCriteria = Object.assign(criteria, selectedFields);
        this.$store.dispatch(RTPS_HISTORY_EXPORT, mergedCriteria);
      }
    },
    saveExportFields(fields) {
      this.$store.commit(SAVE_RTPS_EXPORT_FIELDS, fields);
    },
    addNdc(ndc) {
      this.ndcSelected.push(ndc);
    },
    addNpi(npi) {
      this.npiSelected.push(npi);
    },
    changePage(page) {
      this.search();
    },
    getCriteria() {
      this.selectedRange[0].setHours(0, 0, 0, 0);
      this.selectedRange[1].setHours(23, 59, 59, 999);

      let criteria = {
        startDate: new Date(this.selectedRange[0].toUTCString()).toISOString(),
        endDate: new Date(this.selectedRange[1].toUTCString()).toISOString(),
        ndcs: this.ndcSelected,
        npis: this.npiSelected,
        offerQualifications: this.selectedOfferQualifications,
        drugName: this.drugName,
        partnerName: this.partnerName,
        page: this.currentPage,
        size: this.size,
        sortDesc: this.sortDesc,
        sortBy: this.sortBy
      };

      if (this.enableOfferDisposition) {
        criteria.suggestionOfferStatuses = this.selectedSuggestionOfferStatuses;
      }

      return criteria;
    },
    sortingChanged(ctx) {
      this.sortDesc = ctx.sortDesc;
      this.sortBy = ctx.sortBy;
      this.search();
    }
  }
};

function getStartDate() {
  let startDate = new Date();
  startDate.setDate(startDate.getDate() - 7);
  startDate.setHours(0, 0, 0, 0);
  return startDate;
}

function getEndDate() {
  let endDate = new Date();
  endDate.setHours(23, 59, 59, 999);
  return endDate;
}
</script>



// WEBPACK FOOTER //
// src/views/RTPSPortal.vue